import { LayoutGrid, List } from 'lucide-react'

export type CollectionViewMode = 'cards' | 'table'

export function CollectionViewToggle({
  value,
  onChange,
}: {
  value: CollectionViewMode
  onChange: (value: CollectionViewMode) => void
}) {
  return <div className="collection-view-toggle" role="group" aria-label="Collection view">
    <button
      type="button"
      className={value === 'cards' ? 'active' : ''}
      aria-pressed={value === 'cards'}
      onClick={() => onChange('cards')}
    >
      <LayoutGrid size={15}/>
      <span>Cards</span>
    </button>

    <button
      type="button"
      className={value === 'table' ? 'active' : ''}
      aria-pressed={value === 'table'}
      onClick={() => onChange('table')}
    >
      <List size={15}/>
      <span>Table</span>
    </button>
  </div>
}

